import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';
import LocalMsgModalSpinner from '../../../../components/LocalMsgModalSpinner';
import { httpApiGetText } from '../../../../lib';
import * as env from '../../../../env';

const ModalDestino = (props: {Show: boolean, Title: string, Icon: string, Message: string, BtnOkName: string, BtnNokName: string, 
                  HandlerClickOk: any, HanlerdClickNok: any, item: any, IdDestino: number}) => {

    const [sHCarga, setSHCarga] = useState(false);  
    const [data, setData] = useState<any>([]);  
    const [dataDeterioro, setDataDeterioro] = useState<any>([]);     
    const [option, setOption] = useState('0');     
    let [optionDeterioro, setOptionDeterioro] = useState("-1");      
    const [cantidad, setCantidad] = useState(0);         
   
    const selected = (evnt: any) =>{
        setOption(evnt.target.value);
    }

    const GetDestinosList = async () => {

        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/MermaDestino?Pais=CL&Destino=${props.IdDestino}`;     
        const response = await httpApiGetText(recurso, {
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        });
        setSHCarga(false);       
        if (response.code >= 400){
            console.log("Error en el servicio de la Api");
        }else{

            const dt = await JSON.parse(response.message);
            await setData([...dt]);
            setOption(props.item.DEST_ID);
        }
    }

    const GetDeterioroList = async () => {

        setSHCarga(true);
        const recurso = `${env.REACT_APP_API_URL}/api/Mermas?Pais=CL&Negocio=${props.item.NEGOCIO}`;     
        const response = await httpApiGetText(recurso, {
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        });
        setSHCarga(false);    
        //console.log("props: ", props);   
        if (response.code >= 400){
            console.log("Error en el servicio de la Api");
        }else{

            const dt = await JSON.parse(response.message);
            await setDataDeterioro([...dt]);
        }          
    }    

    useEffect(()=>{
        
        GetDestinosList();
        GetDeterioroList(); 

        setCantidad(props.item.CANTIDAD);

        setOptionDeterioro((props.item.ID_DETERIORO === null) ? "0" : props.item.ID_DETERIORO);  
        //console.log("item: ", props.item);

    }, []);
    
 return (
      <div>
        <Modal show={props.Show} centered={true} size="lg" >
            <Modal.Header  >
                <Modal.Title className='h3 text-center'>
                    {                        
                        props.Title
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row d-flex justify-content-center w-100'>
                    <div className='col-lg-4 col-md-12'>
                        <label htmlFor="">Tipo documento</label>                        
                        <select  className="form-select" id="sizeTag" aria-label="Default select example" value={option} onChange={selected}>
                            <option key={-1} value={"0"}>Seleccione una opción</option>
                            {
                                data.map((dta: any, idx: number)=><option key={idx} value={dta.DEST_ID}>{dta.DEST_DESCRIPCION}</option>)
                            }
                        </select>                    
                    </div> 
                    <div className='col-lg-4  col-md-12'>
                        <label htmlFor="">Tipo Deterioro</label>
                        <select  className="form-select" id="sizeTag" aria-label="Default select example" value={optionDeterioro} 
                            onChange={(evnt: any)=>{
                                setOptionDeterioro(evnt.target.value);
                            }
                            }>
                            <option key={-1} value={"0"}>Seleccione una opción</option>
                            {
                                dataDeterioro.map((dta: any, idx: number)=><option key={idx} value={dta.ID_DETERIORO}>{dta.DESCRIPCION_DET}</option>)
                            }
                        </select>
                    </div>                        
                    <div className='col-lg-4  col-md-12'>
                            <label htmlFor="">Cantidad</label>
                            <input type="number" min={0} className='form-control text-end' value={cantidad} onChange={(evnt: any)=>setCantidad(evnt.target.value)} />
                    </div>                         
                </div>               
            </Modal.Body>                
            <Modal.Footer className=''>
                {
                    (props.BtnOkName) 
                        ? 
                        <Button type="button" className="btn btn-success " 
                            disabled={(cantidad <= 0) || (option === '0') || ((optionDeterioro === '0') || (optionDeterioro === '-1'))}  
                            onClick={()=>props.HandlerClickOk(option, cantidad, optionDeterioro)}>
                            {props.BtnOkName}
                        </Button>
                        : <div></div>
                }      
                {
                    (props.BtnNokName) 
                        ? 
                        <Button type="button" className="btn btn-danger " onClick={props.HanlerdClickNok}>
                            {props.BtnNokName}
                        </Button>
                        : <div></div>
                }                                      
            </Modal.Footer>
        </Modal>    
        {sHCarga && <LocalMsgModalSpinner 
                    Show={sHCarga}
                    text="Un momento porfavor, procesando..."
                    color="#FF7588"
                /> }           
      </div>
  );
}

export default ModalDestino;